/* eslint-disable prettier/prettier */
import { createSlice } from '@reduxjs/toolkit'

const dashboardReducer = createSlice({
    name: 'dashboardReducer',
    initialState: {
        dashboardData:{} ,
        
    },
    reducers: {
        
        setDashboard(state, action) {
            state.dashboardData = action.payload.value
        }
    },
})

export const { setDashboard} = dashboardReducer.actions


export default dashboardReducer.reducer